import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/amenities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::index
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:31
* @route '/amenities'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/amenities/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::create
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:50
* @route '/amenities/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::store
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:64
* @route '/amenities'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/amenities',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::store
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:64
* @route '/amenities'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::store
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:64
* @route '/amenities'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::store
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:64
* @route '/amenities'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::store
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:64
* @route '/amenities'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
export const edit = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/amenities/{amenity}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
edit.url = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { amenity: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { amenity: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            amenity: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        amenity: typeof args.amenity === 'object'
        ? args.amenity.id
        : args.amenity,
    }

    return edit.definition.url
            .replace('{amenity}', parsedArgs.amenity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
edit.get = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
edit.head = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
const editForm = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
editForm.get = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::edit
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:79
* @route '/amenities/{amenity}/edit'
*/
editForm.head = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::update
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:94
* @route '/amenities/{amenity}'
*/
export const update = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/amenities/{amenity}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::update
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:94
* @route '/amenities/{amenity}'
*/
update.url = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { amenity: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { amenity: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            amenity: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        amenity: typeof args.amenity === 'object'
        ? args.amenity.id
        : args.amenity,
    }

    return update.definition.url
            .replace('{amenity}', parsedArgs.amenity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::update
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:94
* @route '/amenities/{amenity}'
*/
update.put = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::update
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:94
* @route '/amenities/{amenity}'
*/
const updateForm = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::update
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:94
* @route '/amenities/{amenity}'
*/
updateForm.put = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::destroy
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:106
* @route '/amenities/{amenity}'
*/
export const destroy = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/amenities/{amenity}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::destroy
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:106
* @route '/amenities/{amenity}'
*/
destroy.url = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { amenity: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { amenity: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            amenity: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        amenity: typeof args.amenity === 'object'
        ? args.amenity.id
        : args.amenity,
    }

    return destroy.definition.url
            .replace('{amenity}', parsedArgs.amenity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::destroy
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:106
* @route '/amenities/{amenity}'
*/
destroy.delete = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::destroy
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:106
* @route '/amenities/{amenity}'
*/
const destroyForm = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Amenities\AmenityController::destroy
* @see app/Http/Controllers/Admin/Amenities/AmenityController.php:106
* @route '/amenities/{amenity}'
*/
destroyForm.delete = (args: { amenity: string | { id: string } } | [amenity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const amenities = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default amenities